import nav from './components/nav';
import freteGratis from './components/banner-frete-gratis';
import product from './components/product';
import login from './components/login';
import checkout from './components/checkout';
import cadastroEmpresa from './components/cadastro-empresa';
import about from './components/about';
import 'lazysizes';

jQuery(function ($) {

    nav.init($);
    freteGratis.init();
    product.init($);
    login.init($);
    checkout.init($);
    cadastroEmpresa.init($);
    about.init($);
    //////// HOME

    $('.main-slider .main-banners').slick({
        nav: true,
        dots: true,
        lazyLoad: 'ondemand',
    });

    //Slider produtos em destaque

    // $('.storefront-product-section.destaques ul').slick({
    //     slidesToShow: 3,
    //     slidesToScroll: 3,
    //     nav: true,
    //     infinite: false,
    //     responsive:[
    //         {
    //             breakpoint: 767,
    //             settings: 'unslick'
    //         },
    //
    //     ]
    // });

    // Blog posts

    $('.blog-posts .items').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        dots: true,
        infinite: false,
        responsive:[
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },

        ]
    });

    // ADD TO CART ALERT
    $( document.body ).on( 'added_to_cart', function(e, fragments, cart_hash, $button){
        let container = $($button).closest('li.product');
        let productData = {
            name: container.find('.woocommerce-loop-product__title').text(),
            imageTag: container.find('.attachment-woocommerce_thumbnail').first(),
        };
        // console.log(productData);
    });

    // DETECT MIX BLEND MODE

    if (typeof window.getComputedStyle(document.body).mixBlendMode !== 'undefined') {
        document.documentElement.className += "mix-blend-mode";
    }

    // EFEITO TILT
    $('section.cabelos figure').tilt({maxTilt:10,perspective:2000});

    //add simple support for background images lazy load:
    document.addEventListener('lazybeforeunveil', function(e){
        var bg = e.target.getAttribute('data-bg');
        if(bg){
            e.target.style.backgroundImage = 'url(' + bg + ')';
        }
    });

    // Submete os formulários de newsletter para o RDSTATION
    $('.cta-desconto').submit(function (event) {
        event.preventDefault();

        let form = $(this);
        let btnSubmit = $(this).find('button[type=submit]');
        let postData = $(this).serializeArray();
        let rdToken = $('meta[property="rd-token"]').attr('content');

        postData.push({ 'name': 'token_rdstation', 'value': rdToken });

        btnSubmit.attr('disabled', 'disabled');
        RdIntegration.post(postData, function (r) {

            if (r.responseJSON && r.responseJSON.result && r.responseJSON.result === 'success') {
                $('.overlay-cta').removeClass('hidden');
                form[0].reset();
            } else {
                alert('Não foi possível processar sua solicitação');
            }
            btnSubmit.removeAttr('disabled');
        });

        bddm.identify({
            email: form.find('[name=email]').val(),
            name: form.find('[name=nome]').val()
        });

        bddm.trackPageview();

        return false;
    });

    // Submete os formulários de newsletter para o RDSTATION
    $('.footer-newsletter').submit(function (event) {
        event.preventDefault();

        var form = $(this);
        var btnSubmit = $(this).find('button[type=submit]');
        var postData = $(this).serializeArray();
        var rdToken = $('meta[property="rd-token"]').attr('content');

        postData.push({ 'name': 'token_rdstation', 'value': rdToken });

        btnSubmit.attr('disabled', 'disabled');
        RdIntegration.post(postData, function (r) {

            if (r.responseJSON && r.responseJSON.result && r.responseJSON.result === 'success') {
                alert('E-mail cadastrado com sucesso!');
                form[0].reset();
            } else {
                alert('Não foi possível processar sua solicitação');
            }
            btnSubmit.removeAttr('disabled');
        });

        bddm.identify({
            email: form.find('[name=email]').val(),
        });

        bddm.trackPageview();

        return false;
    });

});